<template>
    <v-sheet class="basket-items">
        <v-sheet v-for="(merchantItems, merchantId) in getMerchantizedItems()" :key="merchantId">
            <template v-if="Object.values(getMerchantizedItems()).length > 1">
                <v-subheader class="pa-0 ma-0">
                    <a
                        v-if="getMerchantLink(merchantItems[Object.keys(merchantItems)[0]])"
                        class="title"
                        :href="getMerchantLink(merchantItems[Object.keys(merchantItems)[0]])"
                    >
                        {{getMerchantName(merchantItems[Object.keys(merchantItems)[0]])}}
                    </a>

                    <p v-else class="title">{{getMerchantName(merchantItems[Object.keys(merchantItems)[0]])}}</p>
                </v-subheader>
            </template>

            <v-container fluid grid-list-xl class="pa-0">
                <v-layout row wrap>
                    <v-flex
                        xs12
                        v-for="item in merchantItems"
                        :key="`${item.hash}`"
                    >
                        <v-divider/>

                        <basket-item
                            :item="item"
                            :floating="floating"
                            :selfPickup="selfPickup"
                            :noControls="noControls"
                            :key="`${item.hash}`"
                            :quantity="item.quantity"
                            :hide-tier-price-info="hideTierPriceInfo"
                            :flat="flatCards"
                         />
                    </v-flex>

                    <template v-if="Object.values(getMerchantizedItems()).length > 1">
                        <template v-if="!noTotals">
                            <v-flex  xs12 md6 offset-md6>
                                <v-card v-if="getMerchantShippingPrice(merchantId) != undefined">
                                    <v-card-text>
                                        <v-layout row wrap>
                                            <v-flex xs8>
                                                <span>{{ 'shipping' | translation }}</span>
                                            </v-flex>

                                            <v-flex xs4 text-xs-right>
                                                <span>{{getMerchantShippingPrice(merchantId) | currency}}</span>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-flex>

                            <v-flex  xs12 md6 offset-md6 v-if="false">
                                <v-card>
                                    <v-card-text>
                                        <v-layout row wrap>
                                            <v-flex xs8>
                                                <span>{{ 'discount' | translation }}</span>
                                            </v-flex>

                                            <v-flex xs4 text-xs-right>
                                                <span>{{ '-100' | translation }}</span>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-flex>

                            <v-flex xs12 md6 offset-md6>
                                <v-card>
                                    <v-card-text>
                                        <v-layout row wrap>
                                            <v-flex xs8>
                                                <span>{{ 'Subtotal' | translation }}</span>
                                            </v-flex>

                                            <v-flex xs4 text-xs-right>
                                                <span>{{getMerchantTotal(merchantId) | currency}}</span>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </template>
                    </template>
                </v-layout>
            </v-container>
        </v-sheet>

        <v-container fluid grid-list-xl class="pa-0 pt-3">
            <v-divider/>
            <v-divider/>
            <v-divider/>
            <v-divider/>
            <v-divider/>

            <v-layout
                row
                wrap
                align-top
                v-if="!noTotals"
                class="justify-end"
            >
                <v-flex :class="{'xs12 md6 order-md1 order-xs2': !floating, 'xs12 order-xs2': floating}" class="py-0">
                    <v-card v-if="coupon" :flat="flatCards">
                        <v-card-text :class="{'pt-0': $vuetify.breakpoint.smAndDown}">
                            <coupon button-color="default" class="mb-3"/>

                            <slot name="afterCoupon"/>
                        </v-card-text>
                    </v-card>
                </v-flex>

                <v-flex :class="{'xs12 md6 order-md2 order-xs1': !floating, 'xs12 order-xs1': floating}" class="py-0">

                    <v-layout row wrap class="font-weight-bold pl-2 pt-3">
                        <p>Versandanbieter auswählen</p>
                    </v-layout>
                    <v-card :flat="flatCards" class="shipping-providers">
                        <v-card-text>
                            <v-layout row wrap align-center>
                                <v-flex xs12 pt-0>
                                    <v-radio-group v-model="shippingState">
                                        <v-radio
                                            v-for="shippingType in shippingTypes"
                                            :key="shippingType.id"
                                            :value="shippingType.id"
                                        >
                                            <div slot="label" v-html="getShippingLabel(shippingType)">
                                            </div>
                                        </v-radio>
                                    </v-radio-group>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                    <br>
                    <v-card :flat="flatCards">
                        <v-card-text>
                            <v-layout row wrap align-center v-if="selfPickup">
                                <v-flex xs6>
                                    {{ 'Pick up all items yourself' | translation }}
                                </v-flex>

                                <v-flex xs6>
                                    <v-checkbox
                                        class="input-no-spacing justify-end"
                                        hide-details
                                        v-model="basketPickup"
                                        :disabled="!isVisibleBasketPickup"
                                    />
                                </v-flex>
                            </v-layout>

                            <v-layout row wrap align-end justify-end class="font-weight-bold">
                                <v-flex shrink>
                                    <p class="mb-0" v-if="selectableShipping">{{ 'shipping' | translation }}</p>
                                    <p v-else class="mb-0">
                                        {{ 'Shipping to' | translation }}
                                        {{getDeliveryCountry}}
                                    </p>

                                    <shipping-selector
                                        class="font-weight-medium"
                                        :display-dropdown="selectableShipping"
                                        :loadShippingCountries="selectableShipping"
                                        :actualPricesLoaded="$basket.didActualPricesLoaded()"
                                    />
                                </v-flex>

                                <v-flex shrink v-if="Object.values(getMerchantizedItems()).length < 2">
                                    <v-sheet v-for="(merchantItems, merchantId) in getMerchantizedItems()" :key="merchantId">
                                        <template v-if="!noTotals && getMerchantShippingPrice(merchantId) != undefined">
                                            {{getMerchantShippingPrice(merchantId) | currency}}
                                        </template>
                                    </v-sheet>
                                </v-flex>

                                <v-flex xs12 v-show="shippingPrices && !Object.values(shippingPrices).length">
                                    <v-alert
                                        type="error"
                                        :value="shippingPrices && !Object.values(shippingPrices).length"
                                    >
                                        {{$language.translate('No shipping available!')}}
                                    </v-alert>
                                </v-flex>
                            </v-layout>

                            <v-layout
                                v-if="shippingProviderSelection"
                                v-show="Object.values(shippingProviders).length > 1"
                            >
                                <v-flex sm4 xs12>
                                    <span>{{ 'shipping provider' | translation }}</span>
                                </v-flex>

                                <v-flex sm6 xs8>
                                    <shipping-provider :actualPricesLoaded="$basket.didActualPricesLoaded()"/>
                                </v-flex>
                            </v-layout>

                            <v-layout class="mb-0">
                                <v-flex xs12 class="pa-0">
                                    <product-fees class="pa-2" :fees="$basket.getProductsFeesTotals()"/>
                                </v-flex>
                            </v-layout>

                            <v-divider/>

                            <basket-totals class="pt-2"/>

                            <slot name="afterTotals"/>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>

            <slot name="afterItems"/>

            <template v-if="displayFreeShippingInfo">
                <v-sheet v-for="(merchantItems, merchantId) in getMerchantizedItems()" :key="merchantId">
                    <free-shipping-info
                        :merchantId="parseInt(merchantId)"
                        :merchantTotal="getMerchantTotal(merchantId, true)"
                        :cols="relatedProductsCols"
                    />
                </v-sheet>
            </template>
        </v-container>

        <partly-pickup-modal v-model="showPartlypickupModal"/>
    </v-sheet>
</template>

<script>
    import PartlyPickupModal from "./PartlyPickupModal";
    import {
        mapState,
        mapGetters,
        mapMutations,
        mapActions,
    } from 'vuex';
    import ProductFees from './Basket/ProductFees';
    import ShippingProvider from './Basket/ShippingProvider';
    import {Observable} from 'rxjs';
    import {getProducts} from '@breakmedia/prime-vue-product/src/store/getProducts';
    import ShippingSelector from './ShippingSelector';
    import { debounceTime } from 'rxjs/internal/operators/debounceTime';

    export default {
        name: 'BasketItems',
        props: {
            items: {},
            noControls: Boolean,
            noTotals: Boolean,
            floating: Boolean,
            coupon: Boolean,
            selectableShipping: {
                type: Boolean,
                default: true,
            },
            selfPickup: Boolean,
            displayFreeShippingInfo: {
                type: Boolean,
                default: false
            },
            shippingProviderSelection: Boolean,
            getPriceForAddress: Boolean,
            hideTierPriceInfo: {
                type: Boolean,
                default: false,
            },
            flatCards: Boolean,
            preventLoadProducts: Boolean,
            relatedProductsCols: {
                default: 2,
                type: Number,
            },
            shippingTypes: {
                default: function () {
                    return []
                },
                type: Array,
            },
            value: {
                type: String,
            },
        },
        components: {
            PartlyPickupModal,
            ProductFees,
            ShippingProvider,
        },
        data() {
            return {
                basketItemsValidated: false,
                allItemsPickupable: false,
                showPartlypickupModal: false,
                latestPriceParams: [],
                productsSubscriber: null,
            };
        },
        created() {
            this.productsSubscriber = getProducts(new Observable(subscriber => {
                this.$watch(
                    'basketItems',
                    () => {
                        if (this.preventLoadProducts) {
                            this.prepareBasket();
                        } else {
                            subscriber.next(this.getLoadBasketProductsQuery());
                        }
                    },
                    {
                        deep: true,
                        immediate: true,
                    }
                );
                this.$watch(
                    'deliveryCountryId',
                    () => {
                        if (this.preventLoadProducts) {
                            this.prepareBasket();
                        } else {
                            subscriber.next(this.getLoadBasketProductsQuery());
                        }
                    },
                    {
                        immediate: true,
                    }
                );
            }))
            .pipe(debounceTime(50))
            .subscribe(products => {
                this.prepareBasket(products);
            });
        },
        beforeDestroy() {
            this.productsSubscriber.unsubscribe();
        },
        computed: {
            ...mapState('Basket', [
                'products',
            ]),
            ...mapGetters('Product', [
                'isSellOutOfStock',
                'merchantQuota',
            ]),
            ...mapGetters('Grillshop', ['getShippingTypes', 'getCurrentShippingType']),
            ...mapState(ShippingSelector.name, ['shippingPrices', 'shippingProviders']),
            getDeliveryCountry() {
                return this.$language.translate(this.$country.getCountryNameBy('iso_2', this.$order.getDeliveryCountry()));
            },
            basketPickup: {
                get() {
                    let pickupItemsCount = 0;
                    const basketItems = this.$basket.getBasketItems();
                    for (const hash of Object.keys(basketItems)) {
                        if (basketItems[hash].pickup) {
                            pickupItemsCount++;
                        }
                    }

                    return Object.values(basketItems).length > 0 && Object.values(basketItems).length == pickupItemsCount;
                },
                set(val) {
                    let items = this.getMerchantizedItems();
                    for (let merchantId of Object.keys(items)) {
                        for (let itemId of Object.keys(items[merchantId])) {
                            let item = items[merchantId][itemId];
                            if (this.$basket.isItemPickupable(item, merchantId)) {
                                this.setItemPickup(item, val);
                            }
                        }
                    }
                    if (!this.allItemsPickupable && val) {
                        this.showPartlypickupModal = true;
                    }
                }
            },
            isVisibleBasketPickup() {
                let pickupAbleItemsCount = 0;
                let totalItemsCount = 0;
                let result = false;
                let items = this.getMerchantizedItems();
                for (let merchantId of Object.keys(items)) {
                    for (let itemId of Object.keys(items[merchantId])) {
                        let item = items[merchantId][itemId];
                        if (this.$basket.isItemPickupable(item, merchantId)) {
                            pickupAbleItemsCount++;
                            result = true;
                        }
                        totalItemsCount++;
                    }
                }
                this.allItemsPickupable = pickupAbleItemsCount === totalItemsCount;
                return result;
            },
            basketItems(){
                return this.items || this.$basket.getBasketItems();
            },
            basketItemsWithProducts() {
                let items = [];

                for (const basketItem of Object.values(this.basketItems)) {
                    let item = Object.assign({}, basketItem);
                    if (this.products[item.product_id]) {
                        item.product = this.products[item.product_id];
                    }
                    items.push(item);
                }

                return items;
            },
            deliveryCountryId() {
                let countryId = null;
                if (this.getCurrentShippingType == '1001') {
                    return this.$country.getCountryBy('iso_2', 'AT').id;
                }
                if (this.getPriceForAddress) {
                    const deliveryCountry = this.$order.getDeliveryCountry();
                    if (deliveryCountry) {
                        const country = this.$country.getCountryBy('iso_2', deliveryCountry);
                        countryId = country && country.hasOwnProperty('id') ? country.id : null;
                    }
                } else {
                    countryId = this.$country.getCountryID();
                }
                return countryId;
            },
            currency() {
                return this.$currency.getSelected();
            },
            shippingState: {
                get() { return this.value },
                set(shippingState) { this.$emit('input', shippingState)}
            }
        },
        methods: {
            ...mapMutations('Basket', [
                'setProducts',
            ]),
            ...mapActions('NotificationModal', [
                'displayNotificationModal',
            ]),
            getLoadBasketProductsQuery() {
                return {
                    ids: Object.values(this.$basket.getBasketProductsIds(this.basketItems)),
                    priceParams: this.$basket.getPriceParams(this.basketItems, this.deliveryCountryId),
                };
            },
            prepareBasket(products = []) {
                if (!products.length && this.preventLoadProducts) {
                    const basketItems = Object.values(this.basketItems);
                    for (const basketItem of basketItems) {
                        products.push(basketItem.product);
                    }
                }
                this.setProducts(products);
                this.cleanUpBasket(products);
                this.$basket.applyPricesSignatures(products);
            },
            getMerchantizedItems(allItems = false) {
                let items;

                if (allItems === true) {
                    items = Object.values(this.$basket.getBasketItems(true));
                } else {
                    items = this.basketItemsWithProducts;
                }

                return this.$basket.getMerchantizedItems(items);
            },
            getMerchantLink(item) {
                let link = "";
                if (
                    item.product &&
                    item.product.merchant[item.options.merchant] &&
                    item.product.merchant[item.options.merchant].data.show_shop &&
                    item.product.merchant[item.options.merchant].url
                ) {
                    link = "/haendler/" + item.product.merchant[item.options.merchant].url;
                }

                return link;
            },
            getMerchantName(item) {
                let name = "";
                if (item.product && item.product.merchant[item.options.merchant]) {
                    name = item.product.merchant[item.options.merchant].data.name;
                }

                return name;
            },
            getMerchantShippingPrice(merchantId) {
                let shippingPrice = 0;
                if (this.shippingPrices && this.shippingPrices.hasOwnProperty(merchantId)) {
                    shippingPrice = this.shippingPrices[merchantId];
                }
                return shippingPrice;
            },
            getMerchantTotal(merchantId, overall = false) {
                let items;

                if (overall === true) {
                    items = Object.values(this.$basket.getBasketItems(true));
                } else {
                    items = this.basketItemsWithProducts;
                }

                return this.$basket.getMerchantTotal(merchantId, items);
            },
            setItemPickup(item, value) {
                if (value != undefined) {
                    item.pickup = value;
                }
                this.$basket.updateBasketItem(item);
            },
            cleanUpBasket(products) {
                const productsToValidate = [];
                const productIds = this.$basket.getBasketProductsIds(this.basketItems);
                const hashes = Object.keys(productIds);
                for (const hash of hashes) {
                    const productId = productIds[hash];

                    let foundProduct;

                    for (const product of products) {
                        if (productId === product.id) {
                            const merchants = Object.values(product.merchant);
                            for (const merchant of merchants) {
                                if (merchant.price && Object.values(merchant.price).length) {
                                    foundProduct = product;
                                    break;
                                }
                            }

                            if (foundProduct) {
                                break;
                            }
                        }
                    }

                    if (foundProduct) {
                        productsToValidate.push({
                            basketItem: this.basketItems[hash],
                            product: foundProduct,
                            hash,
                        });
                    } else {
                        this.$basket.removeBasketItem(hash);
                    }
                }
                if (productsToValidate.length && !this.basketItemsValidated) {
                    this.basketItemsValidated = true;
                    this.validateProducts(productsToValidate);
                }
            },
            validateProducts(productsToValidate) {
                this.$nextTick(() => {
                    const removedProductsMessages = [];
                    const quantityMessages = [];
                    for (const item of productsToValidate) {
                        const {
                            basketItem,
                            product,
                            hash,
                        } = item;
                        const isSellOutOfStock = this.isSellOutOfStock(product, basketItem.catalog_item_id, basketItem.options.merchant);
                        const quota = this.merchantQuota(product, basketItem.catalog_item_id, basketItem.options.merchant);
                        if (
                            quota !== null &&
                            quota < basketItem.quantity &&
                            !isSellOutOfStock
                        ) {
                            const itemTitle = this.$basket.getItemTitle(basketItem);
                            if (quota == 0) {
                                removedProductsMessages.push(`- ${itemTitle}`);
                                this.$basket.removeBasketItem(hash);
                            } else {
                                quantityMessages.push(`- ${itemTitle}`);
                                basketItem.quantity = parseInt(quota);
                                this.$basket.updateBasketItem(basketItem);
                            }
                        }
                    }
                    if (removedProductsMessages.length || quantityMessages.length) {
                        const messages = [];
                        if (removedProductsMessages.length) {
                            messages.push(this.$language.translate('ZERO_QUOTA_PRODUCTS_REMOVED'));
                            messages.push(removedProductsMessages.join('<br />'));
                        }
                        if (quantityMessages.length) {
                            messages.push(this.$language.translate('LOW_QUOTA_QUANTITY_CHANGED'));
                            messages.push(quantityMessages.join('<br />'));
                        }
                        this.displayNotificationModal({
                            message: messages.join('<br />'),
                            closeButtonText: 'BASKET_CHANGED_NOTIFICATION_CLOSE_BTN',
                            persistent: true,
                        });
                    }
                });
            },
            getShippingLabel(shipping) {
                let that = this;
                const translate = label => ' <span>' + that.$language.translate(label) + '</span>';
                let shippingLabel = '';
                switch (shipping.name) {
                    case 'GLS':
                        shippingLabel = that.$language.translate(shipping.name) + translate('(1 - 3 Tage Standardversand)');
                        break;
                    case 'DHL':
                        shippingLabel = that.$language.translate(shipping.name) + translate('(1 - 2 Tage Lieferzeit + € 1,50 Aufpreis)');
                        break;
                    default:
                        shippingLabel = that.$language.translate(shipping.name);
                }

                return shippingLabel;
            },
        },
    };
</script>
